var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_916_8023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_916_8023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help",
    d: "M8.9625 13.5C9.225 13.5 9.447 13.4092 9.6285 13.2277C9.8095 13.0467 9.9 12.825 9.9 12.5625C9.9 12.3 9.8095 12.0782 9.6285 11.8972C9.447 11.7157 9.225 11.625 8.9625 11.625C8.7 11.625 8.478 11.7157 8.2965 11.8972C8.1155 12.0782 8.025 12.3 8.025 12.5625C8.025 12.825 8.1155 13.0467 8.2965 13.2277C8.478 13.4092 8.7 13.5 8.9625 13.5ZM8.2875 10.6125H9.675C9.675 10.2 9.722 9.875 9.816 9.6375C9.9095 9.4 10.175 9.075 10.6125 8.6625C10.9375 8.3375 11.1938 8.028 11.3813 7.734C11.5688 7.4405 11.6625 7.0875 11.6625 6.675C11.6625 5.975 11.4062 5.4375 10.8937 5.0625C10.3812 4.6875 9.775 4.5 9.075 4.5C8.3625 4.5 7.7845 4.6875 7.341 5.0625C6.897 5.4375 6.5875 5.8875 6.4125 6.4125L7.65 6.9C7.7125 6.675 7.85325 6.43125 8.07225 6.16875C8.29075 5.90625 8.625 5.775 9.075 5.775C9.475 5.775 9.775 5.88425 9.975 6.10275C10.175 6.32175 10.275 6.5625 10.275 6.825C10.275 7.075 10.2 7.30925 10.05 7.52775C9.9 7.74675 9.7125 7.95 9.4875 8.1375C8.9375 8.625 8.6 8.99375 8.475 9.24375C8.35 9.49375 8.2875 9.95 8.2875 10.6125ZM9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.5155 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.4845 12.8375 2.091 11.925C1.697 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.697 6.9875 2.091 6.075C2.4845 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48425 6.075 2.09025C6.9875 1.69675 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69675 11.925 2.09025C12.8375 2.48425 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5155 5.1625 15.909 6.075C16.303 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.303 11.0125 15.909 11.925C15.5155 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5155 11.925 15.909C11.0125 16.303 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0937 14.4187 13.2562 13.2562C14.4187 12.0937 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2562 4.74375C12.0937 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0937 4.74375 13.2562C5.90625 14.4187 7.325 15 9 15Z",
    fill: "#F6F6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7a7eaf45e2096563bef37e1d7e1853bf.svg";
export { ForwardRef as ReactComponent };